const SavedModal = () => {
  const modalWrapper = document.querySelector(".saved-modal__wrapper");
  const preloader = document.getElementById("preloader");
  const mailChimpFormProduct = document.querySelector(".form-image .mc4wp-form");
  const mailChimpFormProject = document.querySelector(".hero-form__form--projects .mc4wp-form");

  if (mailChimpFormProduct) {
    const openerHTML = '<button type="button" class="btn btn--grey-700 saved-modal__opener">Save data for later</button>';
    const submitInput = mailChimpFormProduct.querySelector("input[type='submit']");
    if (submitInput) {
      const submitLine = submitInput.closest(".row p");

      submitLine.insertAdjacentHTML('beforeend', openerHTML);

      const opener = submitLine.querySelector(".saved-modal__opener");

      opener.addEventListener("click", () => {
        modalWrapper.classList.add("opened");
      });
    }
  }

  if (mailChimpFormProject) {
    const openerHTML = `<div class="hero-form__btns-right">
                          <button type="button" class="btn btn--white saved-modal__opener">Save for later</button>
                          <button type="button" class="information-btn">
                            i
                            <span class="information-span">
                              <span>You will be able to collect several preview reports to download them all at once (a floating window will appear up)</span>
                              <span>Or use the button “download now” to upload only this one.</span>
                              <span class="steps">
                                <span>1. Fill in the details in the form</span>
                                <span>2. Confirm your email (you will be sent an email)</span>
                                <span>3. Get a preview</span>
                              </span>       
                            </span>
                          </button>
                        </div>`;
    const submitInput = mailChimpFormProject.querySelector("input[type='submit']");

    if (submitInput) {
      const submitLine = submitInput.closest(".row p");

      submitInput.value = "Download";
      submitLine.insertAdjacentHTML('beforeend', openerHTML);

      const opener = submitLine.querySelector(".saved-modal__opener");

      opener.addEventListener("click", () => {
        modalWrapper.classList.add("opened");
      });
    }
  }

  if (modalWrapper) {
    const modal = modalWrapper.querySelector(".saved-modal__modal");
    const savedModalForm = modalWrapper.querySelector(
      ".saved-modal__form .wpcf7-form"
    );
    const footer = modalWrapper.querySelector(".saved-modal__footer");
    const steps = [...modalWrapper.querySelectorAll(".saved-modal__step")];
    const tabs = [...modalWrapper.querySelectorAll(".saved-modal__tab")];
    const continueSelectionBtn = modalWrapper.querySelector(
      ".continue-selectio-btn"
    );
    const closeBtns = [...modalWrapper.querySelectorAll(".close-btn")];
    const nextBtn = modalWrapper.querySelector(".next-btn");
    const prevBtn = modalWrapper.querySelector(".prev-btn");
    const downloadBtn = modalWrapper.querySelector(".download-btn");

    let currentStep = 0;
    
    if (savedModalForm) {
      const requiredInputs = [
        ...savedModalForm.querySelectorAll("input.wpcf7-validates-as-required"),
        ...savedModalForm.querySelectorAll('input[type="checkbox"]'),
      ];

      requiredInputs.forEach((requiredInput) => {
        requiredInput.addEventListener("input", () => checkRequiredInputs(requiredInputs, downloadBtn));
      });
    }

    function checkRequiredInputs(requiredInputs, downloadBtn) {
      console.log("checkRequiredInputs")
        let allInputsFilled = true;

        requiredInputs.forEach((input) => {
          if (input.type === "checkbox") {
            if (!input.checked) {
              allInputsFilled = false;
            }
          } else {
            if (!input.value.trim()) {
              allInputsFilled = false;
            }
          }
        });

        if (allInputsFilled) {
          downloadBtn.disabled = false;
        } else {
          downloadBtn.disabled = true;
        }
    }

    function updateStep() {
      steps.forEach((step, index) => {
        if (index <= currentStep) {
          step.classList.add("active");
        } else {
          step.classList.remove("active");
        }
      });

      tabs.forEach((tab, index) => {
        if (index === currentStep) {
          tab.classList.add("active");
        } else {
          tab.classList.remove("active");
        }
      });

      if (currentStep === 0) {
        prevBtn.classList.add("d-none");
        downloadBtn.classList.add("d-none");
        nextBtn.classList.remove("d-none");
        continueSelectionBtn.classList.remove("d-none");
      } else {
        prevBtn.classList.remove("d-none");
        downloadBtn.classList.remove("d-none");
        nextBtn.classList.add("d-none");
        continueSelectionBtn.classList.add("d-none");
      }

      if (currentStep === 1) {
        prevBtn.classList.remove("d-none");
        downloadBtn.classList.remove("d-none");
        nextBtn.classList.add("d-none");
        continueSelectionBtn.classList.add("d-none");
      } else {
        prevBtn.classList.add("d-none");
        downloadBtn.classList.add("d-none");
        nextBtn.classList.remove("d-none");
        continueSelectionBtn.classList.remove("d-none");
      }

      if (currentStep === 2) {
        footer.classList.add("d-none");
      } else {
        footer.classList.remove("d-none");
      }
    }

    async function postData() {
      if (savedModalForm instanceof HTMLFormElement) {
        let $cards;
        let $page_id;

        const formData = new FormData(savedModalForm);

        formData.append("action", "cart_free");
        formData.append("cards", $cards);
        formData.append("page_id", $page_id);
        // formData.append('nonce', theme.nonce);

        const url = "https://droneii.hotletolux.com.ua/wp-admin/admin-ajax.php";

        try {
          preloader.classList.remove("d-none");

          const response = await fetch(url, {
            method: "POST",
            body: formData,
          });

          if (response.ok) {
            console.log("Form data successfully submitted");
            currentStep = currentStep + 1;
            updateStep();
            preloader.classList.add("d-none");
          } else {
            console.error("Error submitting form data");
          }
        } catch (error) {
          console.error("Fetch error:", error);
        }
      }
    }

    prevBtn.addEventListener("click", () => {
      if (currentStep > 0) {
        currentStep = currentStep - 1;
        updateStep();
      }
    });

    nextBtn.addEventListener("click", () => {
      currentStep = currentStep + 1;
      updateStep();
    });

    downloadBtn.addEventListener("click", () => {
      postData();
    });

    closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener("click", () => {
        modalWrapper.classList.remove("opened");
      });
    });

    modalWrapper.addEventListener("click", (e) => {
      if (e.target === modalWrapper) {
        modalWrapper.classList.remove("opened");
      }
    });

    updateStep();
  }
};

export default SavedModal;

const deleteBtns = [...document.querySelectorAll(".delete-btn")];

if (deleteBtns.length > 0) {
  deleteBtns.forEach((deleteBtn) => {
    deleteBtn.addEventListener("click", (event) => {
      const productId = event.target.value;
      removeCookie(productId);
      const parentItem = event.target.closest(".saved-modal__item");

      if (parentItem) {
        parentItem.remove();
        const result = document.querySelector(".saved-modal__list");
        if (result && result.children.length === 0) {
          document
            .querySelector(".saved-modal__list-message")
            .classList.add("show");
        }
      }
    });
  });
}
